export default __webpack_public_path__ + "static/mitech-client-logo-03-30ed768ad5dadcfee40fafe62caa470f.png";